var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignupGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M10.3 1.5c3.3-1.1 7-1.1 10.3.1 1.8.7 3.5 1.7 4.9 3.1L24 6.2 21.2 9c-.9-.9-2.1-1.6-3.3-1.9-1.4-.4-3-.5-4.5-.2-1.7.4-3.3 1.3-4.6 2.5-1 1-1.8 2.3-2.2 3.6-1.7-1.3-3.3-2.6-5-3.9 1.8-3.5 5-6.3 8.7-7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M.3 13c.3-1.3.7-2.6 1.3-3.9 1.7 1.3 3.3 2.6 5 3.9-.7 1.9-.7 4 0 6-1.7 1.3-3.3 2.6-5 3.9C.1 19.8-.4 16.3.3 13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M15.4 13.2h14.4c.5 2.7.4 5.5-.4 8.1-.7 2.4-2 4.6-3.9 6.4-1.695-1.284-2.836-2.1-4.9-3.8 1.6-1.1 2.7-2.8 3.1-4.7h-8.3v-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M1.6 22.9c1.7-1.3 3.3-2.6 5-3.9.6 1.9 1.9 3.6 3.5 4.7 1 .7 2.2 1.2 3.4 1.5 1.2.2 2.4.2 3.7 0 1.2-.2 2.4-.7 3.4-1.3 1.6 1.3 3.2 2.5 4.9 3.8-1.8 1.6-3.9 2.7-6.3 3.3-2.6.6-5.3.6-7.8-.1-2-.5-3.9-1.5-5.6-2.8-1.7-1.5-3.2-3.3-4.2-5.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupGoogleLogo);
export default __webpack_public_path__ + "static/media/SignupGoogleLogo.bd5fb013ecddd39664fdc0db2d4e52b2.svg";
export { ForwardRef as ReactComponent };